var map = {
	"./book-banner.jpg": 8435,
	"./book-banner111.jpg": 9128,
	"./book-banner22.jpg": 2890,
	"./book-banner33.jpg": 1322,
	"./book-bannerf1.jpg": 718,
	"./book-bannerf2.jpg": 8715,
	"./book-bannerf3.jpg": 7830,
	"./intro.jpg": 3675,
	"./intro2.jpg": 3731,
	"./mission.jpg": 7910,
	"./promotion-banner.jpg": 4104,
	"./promotion-banner1.jpg": 8935,
	"./promotion-banner2.jpg": 7348,
	"./promotion-birthday-banner.jpg": 2453,
	"./promotion-dec-banner.jpg": 4679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;